<template>
    <veui-form ref="sortForm" :data="data" class="sort-form">
        <veui-span>排序条件：</veui-span>
        <div v-for="(item, idx) in data" :key="idx" class="sort-field-wrap">
            <veui-field :field="`${idx}.field`"
                :name="`${idx}.field`"
                rules="required">
                <veui-select :options="fieldDatasource"
                    :value="data[idx].field"
                    @change="val => emit(idx, val, 'field')"/>
            </veui-field>
            <veui-field>
                <veui-select :options="sortDatasource" class="sort-order-select"
                    :value="data[idx].sort"
                    @change="val => emit(idx, val, 'sort')"/>
                <veui-button @click="removeItem(idx)">移除</veui-button>
            </veui-field>
        </div>
        <veui-button @click="addItem" :disabled="!canAdd" class="add-btn">增加排序项</veui-button>
    </veui-form>
</template>

<script>
import {Form, Field, Select, Button, Span} from 'veui';
import {map, isNumber, get, uniq} from 'lodash';

export default {
    name: 'Sort',
    components: {
        'veui-form': Form,
        'veui-field': Field,
        'veui-select': Select,
        'veui-button': Button,
        'veui-span': Span
    },
    props: {
        fields: {
            type: Array,
            required: true
        },
        value: String,
        maxCount: Number
    },
    model: {
        event: 'change',
        prop: 'value'
    },
    data() {
        return {
            sortDatasource: [
                {label: '升序', value: '1'},
                {label: '降序', value: '-1'}
            ]
        };
    },
    computed: {
        fieldDatasource() {
            return map(this.fields, i => ({value: i.identify, label: i.name}));
        },
        data() {
            return this.parseValue(this.value);
        },
        canAdd() {
            return isNumber(this.maxCount)
                ? this.maxCount > get(this.data, 'length', 0)
                : true;
        }
    },
    methods: {
        addItem() {
            let data = this.data.slice();
            data.push({field: '', sort: '1'});
            this.$emit('change', this.stringifyData(data));
        },
        removeItem(idx) {
            let data = this.data.slice();
            data.splice(idx, 1);
            this.$emit('change', this.stringifyData(data));
        },
        async validate() {
            let valid = await this.$refs.sortForm.validate();
            if (valid === true) {
                let allKeys = this.data.map(i => i.field);
                if (allKeys.length !== uniq(allKeys).length) {
                    return -1;
                }
            }
            return valid;
        },
        stringifyData(data) {
            return data.map(({field, sort}) => `${field}:${sort}`).join('|');
        },
        parseValue(value) {
            if (value) {
                return value.split('|').map(i => {
                    let [field, sort] = i.split(':', 2);
                    return {field, sort};
                });
            }
            return [];
        },
        emit(idx, val, field) {
            let data = this.data.slice();
            data[idx] = {
                ...data[idx],
                [field]: val
            };
            this.$emit('change', this.stringifyData(data));
        }
    }
};
</script>

<style lang="less">
.sort-form {
    .veui-field-no-label:before {
        width: 20px;
    }
    .veui-field {
        display: inline-block;
    }
    .sort-field-wrap {
        .sort-order-select.veui-select {
            width: 80px;
            min-width: auto;
        }
    }
    .add-btn {
        margin-left: 20px;
    }
}
</style>
